import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { getDebitAccount, getDebitAccounts } from '@/react-query/services/account';

import { DebitAccount } from '@generated-types';

export const useDebitAccountsQuery = <T = DebitAccount[]>(
    options?: Omit<UseQueryOptions<DebitAccount[], Error, T>, 'queryKey' | 'queryFn'>,
) => {
    return useQuery<DebitAccount[], Error, T>({
        queryKey: ['DebitAccounts'],
        queryFn: getDebitAccounts,
        ...options,
    });
};

export const useDebitAccountByIdQuery = <T = DebitAccount>(
    accountId?: string,
    options?: Omit<UseQueryOptions<DebitAccount, Error, T>, 'queryKey' | 'queryFn'>,
) => {
    return useQuery<DebitAccount, Error, T>({
        queryKey: ['DebitAccount', accountId],
        queryFn: () => getDebitAccount(accountId!),
        ...options,
        enabled: options?.enabled && !!accountId,
    });
};
